/** Sui framework package id on DGC (same as 0x2). */
export const CPC_FRAMEWORK = '0x0000000000000000000000000000000000000000000000000000000000000002';
/** Native coin type: `0x2::dgc::DGC`. */
export const DGC_TYPE = `${CPC_FRAMEWORK}::dgc::DGC`;
/** @deprecated use DGC_TYPE */
export const CPC_TYPE = DGC_TYPE;
/**
 * Mainnet DATA type tag (CLOB quote / bridge asset). Override via `VITE_CPC_DATA_COIN_TYPE`
 * or pass `dataTypeTag` into lock builders.
 */
export const DEFAULT_DATA_TYPE = '0xe3129e7a8e43d32c967d751f037028797e0be1328204d73b917420ba7ede2a6f::data::DATA';
export const MIST_PER_DGC = 1000000000n;
/** @deprecated use MIST_PER_DGC */
export const MIST_PER_CPC = MIST_PER_DGC;
export const DEFAULT_CPC_RPC_URL = 'https://rpc.dgclabs.cc';
